import { render, staticRenderFns } from "./pondDetails.vue?vue&type=template&id=ef4bf19a&"
import script from "./pondDetails.vue?vue&type=script&lang=js&"
export * from "./pondDetails.vue?vue&type=script&lang=js&"
import style0 from "./pondDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports